import React from 'react'

const ErrorPage = () => <div>ERROR PAGE 404</div>

export default ErrorPage



// WEBPACK FOOTER //
// ./src/components/pages/ErrorPage.js